import { useLogin } from "../../api/useLoginApi";

export type RefreshToken = {
  access_token: string;
  expires_in: number;
};

export function useRefreshAuthToken() {
  const api = useLogin();

  const refreshToken = async (): Promise<RefreshToken | null> => {
    try {
      const { access_token, expires_in } = await api.refreshToken();
      return { access_token, expires_in };
    } catch (e) {
      return null;
    }
  };

  return { refreshToken };
}
